<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-12 col-sm-12">
                <div class="d-flex justify-content-end">
                  <p>Published: {{ v$.form.published_at.$model ? formatRelativeTime(v$.form.published_at.$model ) : '-' }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <h1 class="mb-3">{{ v$.form.header.$model }}</h1>
            <p class="mb-3 h4 font-weight-normal">{{ v$.form.sub_header.$model }}</p>
            <p class="mb-3">Author by: WAPPIN</p>
            <div class="preview-content-description" v-html="v$.form.description.$model"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import moment from 'moment';
import blogsNotifApi from '../../api/blogNotif';
import popupErrorMessages from '../../library/popup-error-messages';

export default {
  name: 'Detail Notification Blogs',
  metaInfo: {
    title: 'Detail Notification Blogs',
  },
  data() {
    return {
      moment,
      loading: {
        detail: false,
      },
      form: {
        header: '',
        sub_header: '',
        description: '',
        tags: 'News',
        published_at: '',
        published_stop: '',
        video: '',
      },
      tags: ['News', 'Announcement'],
      loader: null,
      loaderStack: 0,
    };
  },
  validations() {
    return {
      form: {
        header: { required },
        sub_header: { required },
        description: { required },
        tags: { required },
        published_at: { required },
        published_stop: {},
        video: {},
      },
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  computed: {
    userProfile() {
      return this.$store.state.auth.userProfile || {};
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    checkPermission() {
      const users = this.$store.state.backOffice.userProfile;
      const path = this.$router.currentRoute.fullPath;
      const permission = users.permissions.find((v) => path.includes(v.path));
      return permission.configuration;
    },
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async getDetail() {
      this.loading.detail = true;
      const { id } = this.$route.params;
      await blogsNotifApi.getDetail(id).then(async (response) => {
        await popupErrorMessages(response);
        const {
          header,
          sub_header,
          tags,
          description,
          published_at,
          published_stop,
        } = response.data;
        this.form.header = header;
        this.form.sub_header = sub_header;
        this.form.description = description;
        this.form.tags = tags;
        this.form.published_at = published_at;
        this.form.published_stop = published_stop;
      });
      this.loading.detail = false;
    },
    onChangeUploadFile(file) {
      if (!file) return;
      const videoUrl = URL.createObjectURL(file);
      const videoRegex = /<video[\s\S]*?<\/video>/;
      if (this.form.description.match(videoRegex)) {
        this.form.description = this.form.description.replace(
          videoRegex,
          `<video src="${videoUrl}" controls class="mt-3 w-100" style="max-height: 300px;"></video><br />`,
        );
      } else {
        this.form.description += `<video src="${videoUrl}" controls class="mt-3 w-100" style="max-height: 300px;"></video><br />`;
      }
    },
    formatRelativeTime(date) {
      return moment(date).fromNow();
    },
  },
};
</script>
<style>
  .preview-content-description img, .preview-content-description video {
    max-width: 100%;
    height: auto;
    max-height: 500px;
    object-fit: contain;
    display: block;
  }
  .preview-content-description table {
    width: 100%;
    border-collapse: collapse;
  }
  .preview-content-description table td,
  .preview-content-description table th {
    border: 1px solid #ccc;
    padding: 8px;
    color: #000;
    font-family: "Open Sans", Arial, sans-serif;
    text-align: left;
  }
</style>
